const Footer = () => {
    return (
        <footer className="footer text-center">
            All rights reserved by iCartridge. Powered by <a href="http://www.kromaltd.com/sr" target="_blank">Kroma ltd</a>.
        </footer>
    );
};
export default Footer;